// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dim__properties{width:100%}.dim__properties dl{display:grid;grid-template-columns:-webkit-max-content auto;grid-template-columns:max-content auto;margin:0;-moz-column-gap:26px;column-gap:26px}.dim__properties dt{grid-column-start:1;color:#8a8989}.dim__properties dd,.dim__properties dt{font-style:normal;font-weight:400;font-size:14px;line-height:20px}.dim__properties dd{grid-column-start:2;color:#111}", ""]);
// Exports
module.exports = exports;
